/* eslint-disable react-hooks/exhaustive-deps */
import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import "allotment/dist/style.css";
import MainLayout from "./Components/Layout/MainLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./pages/Auth/protectedRoute";
import { AccessDeniedPage } from "./pages/Auth/accessDenied";
import { useTheme } from "@mui/material";
import ModuleNotAccessible from "./Components/NotFound/ModuleNotAccessible";
import { isAdmin } from "./app/permission/permissionAndRoleCheck";
import { useAppSelector } from "./app/hooks";
import ProjectPage from "./pages/Board/ProjectPage";
import { ROUTES } from "./utils/routes";
import DEFEKT_TRACKER from "./app/permissionNew/defectTracker";
import BoardPage from "./pages/Board/BoardPage";
// import SignIn from "./pages/Auth/login";
import Settings from "./pages/Board/Settings";
import {
  ReactFlow,
  addEdge,
  Background,
  Controls,
  MiniMap,
  useNodesState,
  useEdgesState,
  useReactFlow,
  ReactFlowProvider,
  getSmoothStepPath,
  EdgeLabelRenderer,
  BaseEdge,
  Handle,
  Position,
  NodeResizer,
} from "@xyflow/react";
import "@xyflow/react/dist/style.css";

import ChartWrapper from "./pages/Board/components/PMODashboard/ChartWrapper";
import PublicBugDetail from "./pages/Public/PublicBugDetail";
import { useAgentConnection } from "./hooks/useAgentConnection";
import { useEffect } from "react";
import OauthLoginCallback from "./pages/Auth/oauthCallback";

function App() {
  const theme = useTheme();
  // const myPermissions = JSON.parse(localStorage.getItem("roleDetail")) || [];
  const { roleCodeDetails: myPermissions } = useAppSelector(
    (state) => state.emailAuth,
  );
  const roleCode = localStorage.getItem("userRoleCode");
  const isAdminValid = isAdmin(roleCode);

  const { initializeConnection, cleanup } = useAgentConnection();
  useEffect(() => {
    initializeConnection();
    return () => {
      cleanup();
    };
  }, []);

  const routes = [
    {
      path: "/",
      component: (
        <ProtectedRoute children={<Navigate to={ROUTES.PROJECTS} replace />} />
      ),
    },
    {
      path: "/access-denied",
      component: <AccessDeniedPage />,
    },
    {
      path: "/auth/callback",
      component: <OauthLoginCallback />,
    },
    // Public routes (no authentication required)
    {
      path: ROUTES.PUBLIC_BUG,
      component: <PublicBugDetail />,
    },

    {
      path: ROUTES.PROJECTS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <ProjectPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                      roleCodeDetails: myPermissions,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.MY_TASKS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.DEFECT_TRACKER_SETTINGS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <Settings />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_FEEDBACK,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_FEEDBACK_CONFIG,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_BOARD,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    // Redirect base project path to dashboard
    {
      path: ROUTES.PROJECT_BASE,
      component: <Navigate to="dashboard" replace />,
    },
    // New route-based navigation routes
    {
      path: ROUTES.PROJECT_DASHBOARD,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_BACKLOG,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SPRINTS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SPRINT,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SETTINGS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SETTINGS_MEMBERS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SETTINGS_TAGS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SETTINGS_INTEGRATIONS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SETTINGS_APPEARANCE,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SETTINGS_SNIFFER_AUTOBUG,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_RECURRING_TASKS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_RETROSPECTIVES,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SYSTEM_BUGS,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_SYSTEM_BUGS_DETAIL,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
    {
      path: ROUTES.PROJECT_APPLICATION_LIST,
      component: (
        <ProtectedRoute
          children={
            <MainLayout
              children={
                isAdminValid || DEFEKT_TRACKER.VIEW(myPermissions) ? (
                  <BoardPage
                    reactFlow={{
                      ReactFlow,
                      addEdge,
                      Background,
                      Controls,
                      MiniMap,
                      useNodesState,
                      useEdgesState,
                      useReactFlow,
                      ReactFlowProvider,
                      getSmoothStepPath,
                      EdgeLabelRenderer,
                      BaseEdge,
                      Handle,
                      Position,
                      NodeResizer,
                    }}
                    parentData={{
                      chartWrapper: ChartWrapper,
                    }}
                  />
                ) : (
                  <ModuleNotAccessible />
                )
              }
            />
          }
        />
      ),
    },
  ];

  return (
    <div
      className="App"
      style={{
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
      }}
    >
      <ToastContainer
        theme={theme.palette.mode === "dark" ? "dark" : "light"}
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
      />
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.component} />
        ))}
      </Routes>
    </div>
  );
}

export default App;
